/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '@swimlane/ngx-datatable/release/components/header/header-cell.component';
const styles_DataTableHeaderCellComponent:any[] = ([] as any[]);
export const RenderType_DataTableHeaderCellComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_DataTableHeaderCellComponent,data:{}});
function View_DataTableHeaderCellComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),3,'label',[['class',
      'datatable-checkbox']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted((null as any),['\n        '])),(_l()(),i0.ɵeld(0,
      (null as any),(null as any),0,'input',[['type','checkbox']],[[8,'checked',0]],
      [[(null as any),'change']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('change' === en)) {
          const pd_0:any = ((<any>_co.select.emit(!_co.allRowsSelected)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n      ']))],
      (null as any),(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.allRowsSelected;
        _ck(_v,2,0,currVal_0);
      });
}
function View_DataTableHeaderCellComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),4,'span',[['class',
      'datatable-header-cell-wrapper']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n        '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),1,'span',[['class','datatable-header-cell-label draggable']],
          [[8,'innerHTML',1]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.onSort()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n        '])),
      (_l()(),i0.ɵted((null as any),['\n      ']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.name;
    _ck(_v,2,0,currVal_0);
  });
}
function View_DataTableHeaderCellComponent_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n      ']))],(null as any),(null as any));
}
function View_DataTableHeaderCellComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(16777216,(null as any),(null as any),2,(null as any),
      View_DataTableHeaderCellComponent_4)),i0.ɵdid(540672,(null as any),0,i1.NgTemplateOutlet,
      [i0.ViewContainerRef],{ngTemplateOutlet:[0,'ngTemplateOutlet'],ngOutletContext:[1,
          'ngOutletContext']},(null as any)),i0.ɵpod({column:0,sortDir:1,sortFn:2,
      allRowsSelected:3,selectFn:4}),(_l()(),i0.ɵand(0,(null as any),(null as any),
      0))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.column.headerTemplate;
    const currVal_1:any = _ck(_v,2,0,_co.column,_co.sortDir,_co.sortFn,_co.allRowsSelected,
        _co.selectFn);
    _ck(_v,1,0,currVal_0,currVal_1);
  },(null as any));
}
export function View_DataTableHeaderCellComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵeld(0,(null as any),
      (null as any),13,'div',([] as any[]),(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),
      i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DataTableHeaderCellComponent_1)),
      i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),
          i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DataTableHeaderCellComponent_2)),
      i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),
          i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DataTableHeaderCellComponent_3)),
      i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),
          i0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),[[8,'className',
              0]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i2.DataTableHeaderCellComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.onSort()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n      '])),
      (_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵted((null as any),['\n  ']))],
      (_ck,_v) => {
        var _co:i2.DataTableHeaderCellComponent = _v.component;
        const currVal_0:any = _co.isCheckboxable;
        _ck(_v,4,0,currVal_0);
        const currVal_1:boolean = !_co.column.headerTemplate;
        _ck(_v,7,0,currVal_1);
        const currVal_2:any = _co.column.headerTemplate;
        _ck(_v,10,0,currVal_2);
      },(_ck,_v) => {
        var _co:i2.DataTableHeaderCellComponent = _v.component;
        const currVal_3:any = _co.sortClass;
        _ck(_v,12,0,currVal_3);
      });
}
export function View_DataTableHeaderCellComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'datatable-header-cell',
      [['class','datatable-header-cell']],[[4,'height','px'],[8,'className',0],[1,
          'title',0],[4,'minWidth','px'],[4,'maxWidth','px'],[4,'width','px']],[[(null as any),
          'contextmenu']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('contextmenu' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).onContextmenu($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },View_DataTableHeaderCellComponent_0,RenderType_DataTableHeaderCellComponent)),
      i0.ɵdid(49152,(null as any),0,i2.DataTableHeaderCellComponent,([] as any[]),
          (null as any),(null as any))],(null as any),(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,1).headerHeight;
    const currVal_1:any = i0.ɵnov(_v,1).columnCssClasses;
    const currVal_2:any = i0.ɵnov(_v,1).name;
    const currVal_3:any = i0.ɵnov(_v,1).minWidth;
    const currVal_4:any = i0.ɵnov(_v,1).maxWidth;
    const currVal_5:any = i0.ɵnov(_v,1).width;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5);
  });
}
export const DataTableHeaderCellComponentNgFactory:i0.ComponentFactory<i2.DataTableHeaderCellComponent> = i0.ɵccf('datatable-header-cell',
    i2.DataTableHeaderCellComponent,View_DataTableHeaderCellComponent_Host_0,{sortType:'sortType',
        column:'column',sortAscendingIcon:'sortAscendingIcon',sortDescendingIcon:'sortDescendingIcon',
        allRowsSelected:'allRowsSelected',selectionType:'selectionType',headerHeight:'headerHeight',
        sorts:'sorts'},{sort:'sort',select:'select',columnContextmenu:'columnContextmenu'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./aot_output/~/@swimlane/ngx-datatable/release/components/header/header-cell.component.ngfactory.ts